var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "flex flex-col w-full | block-img-hover",
      attrs: { href: _vm.possibleLangPrefix + "/blog/" + _vm.content.slug },
    },
    [
      _c("div", { staticClass: "relative" }, [
        _c("div", { staticClass: "aspect-w-7 aspect-h-4 w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "absolute w-full h-full top-0 left-0" }, [
          _vm.content.acf.preview_image
            ? _c(
                "picture",
                { staticClass: "absolute w-full h-full top-0 left-0" },
                [
                  _c("img", {
                    staticClass: "w-full h-full object-cover lazyload",
                    attrs: {
                      "data-src": _vm.content.acf.preview_image.url,
                      alt: _vm.content.acf.preview_image.title,
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-md" }, [
        _c("h3", {
          domProps: { innerHTML: _vm._s(_vm.content.title.rendered) },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mt-sm flex items-center justify-start gap-xs flex-wrap",
          },
          _vm._l(_vm.content.categories_objects, function (cat, index) {
            return _c("span", {
              key: index,
              staticClass:
                "py-xxs px-xs text-xs uppercase text-gray-500 border border-gray-600 text-opacity-80 tracking-[2px] font-semibold",
              domProps: { innerHTML: _vm._s(cat.name) },
            })
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-img-hover__icon" }, [
      _c("i", { staticClass: "fa-regular fa-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }